import Api from '@/services/api';
//import qs from 'querystring';

export default {
  send(data) {
    return Api().post('/mail/send', 'mail=' + encodeURIComponent(JSON.stringify(data)))
  }
}